<template>
    <ui-modal>
        <template #header>
            <h3 v-text="'Lista opakowań'" class="mb-0" />
        </template>

        <page-preloader v-if="isLoading" min-height="5rem" />

        <div v-else-if="eans.length" class="coupon-eans-table c-table">
            <div class="c-thead">
                <div v-text="'Frakcja'" class="c-td" />
                <div v-text="'Produkt'" class="c-td" />
                <div v-text="'Kod EAN'" class="c-td" />
                <div v-text="'Liczba sztuk'" class="c-td" />
                <div v-text="'Wartość'" class="c-td" />
            </div>
            <div class="c-tbody">
                <div v-for="ean in eans" :key="ean.ean" class="c-tr">
                    <div class="c-td">
                        <fraction-label
                            v-if="ean.fraction"
                            v-tooltip="ean.fraction.name"
                            class="justify-content-center"
                            style="font-size: 0;"
                            :fraction="ean.fraction"
                        />
                        <span v-else>---</span>
                    </div>
                    <div v-text="ean.name" class="c-td" />
                    <div class="c-td">
                        <div v-text="'Kod EAN'" class="typo-label" />
                        {{ ean.ean }}
                    </div>
                    <div class="c-td">
                        <div v-text="'Liczba sztuk'" class="typo-label" />
                        {{ ean.factor }} szt.
                    </div>
                    <div class="c-td">
                        <div v-text="'Wartość'" class="typo-label" />
                        {{ ean.value | currency }}
                    </div>
                </div>
            </div>
        </div>
        <div v-text="'Brak wyników'" v-else />
    </ui-modal>
</template>

<script>
import { FRACTIONS } from '@/utils/constants/drs/fractions'

export default {
    data: () => ({
        eans: [],
        isLoading: false
    }),

    methods: {
        async loadEans() {
            const { couponEans = [] } = this.$store.getters.modalState.args
            const eanList = [...new Set(couponEans.map(item => item.ean).filter(Boolean))]
            if (!eanList.length) return

            this.isLoading = true
            try {
                // Fetch eans
                const { data, status } = await this.$store.$api.get(
                    'drs/api/proxy/drs/dict/ean/list',
                    {
                        params: { ean_list: eanList.join(',') }
                    }
                )

                if (status !== 200) {
                    throw new Error('Failed to fetch coupon EANs')
                }

                // Map eans
                this.eans = couponEans.map(({ ean, factor }) => {
                    const product = data.eans.find(product => product.ean === ean)
                    const quantity = factor || 0

                    return {
                        ean,
                        factor: quantity,
                        name: product?.name || '---',
                        value: quantity * (product?.value || 0) / 100,
                        fraction: Object.values(FRACTIONS).find(fr => fr.id === product?.fraction)
                    }
                })
            } catch (error) {
                console.error(error)
            } finally {
                this.isLoading = false
            }
        }
    },

    created() {
        this.loadEans()
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.coupon-eans-table {
    --fraction-width: 3rem;
    --column-gap: 0.5rem;

    .c-thead, .c-tr {
        padding: 0;
        gap: var(--column-gap);
    }

    .c-td {
        flex: 0 0 auto;
        min-width: 0;
    }

    .c-td:nth-child(1) {
        width: var(--fraction-width);
    }

    .c-td:nth-child(2) {
        flex: 1;
    }

    .c-td:nth-child(3) {
        width: 25%;
    }

    .c-td:nth-child(4), .c-td:nth-child(5) {
        width: 12.5%;
    }

    .typo-label {
        display: none;
    }

    .c-tr:nth-child(odd) {
        background-color: var(--color-gray-100);
        border-bottom: 1px solid var(--color-gray-200);
    }

    @include media-breakpoint-down(md) {
        .c-thead {
            display: none;
        }

        .c-tr {
            padding: 1rem;
            flex-flow: row wrap;
        }

        .c-td {
            padding: 0;
        }

        .c-td:nth-child(1) {
            padding-top: 2px;
        }

        .c-td:nth-child(2) {
            flex-basis: calc(100% - var(--fraction-width) - var(--column-gap));
        }

        .c-td:nth-child(3), .c-td:nth-child(4), .c-td:nth-child(5) {
            width: calc((100% - var(--column-gap)) / 2);
        }

        .typo-label {
            display: flex;
        }
    }
}
</style>